// extracted by mini-css-extract-plugin
export default {"title":"ModalDialog_title__20Vx+","content":"ModalDialog_content__qZ+yR"};